import { useAuth } from 'hooks';

export const usePermission = () => {
  const { profile } = useAuth();

  const hasPermissionTo = (permissions: string[]): boolean => {
    const actions = profile?.actions;

    if (!actions || !permissions?.length) return false;

    permissions = permissions.map((permission) => permission.toUpperCase());

    return permissions.every((action: string) =>
      actions.includes(action)
    );
  };

  const hasAnyPermissionTo = (permissions: string[]): boolean => {
    const actionList = profile?.actions;

    if (!actionList || !permissions?.length) return false;

    const required = permissions.map((permission) => permission.toUpperCase());

    return required.some((action) => actionList.includes(action));
  };

  return {
    hasPermissionTo,
    hasAnyPermissionTo,
  };
};
